import { handleActions } from 'redux-actions';

export const defaultUserData = {
	name: { value: '喵', status: '', valid: false },
	gender: { value: { value: 'MALE', label: '男' }, status: '', valid: false },
	jobTypes: { value: [], list: [], data: {}, status: '', valid: false },
	birth: { value: '', status: '', valid: false },
	country: { value: [], status: '', valid: false },
	certificate: { value: '', type: [], status: '', valid: false },
	professions: { value: [], list: [], inputValue: '', data: {}, status: '', valid: false },
	phone: {
		value: '',
		country: {
			areaCodes: null,
			dialCode: '886',
			iso2: 'tw',
			name: 'Taiwan (台灣)',
			priority: 0,
		},
		valid: false,
		validate: true,
		status: '',
	},
	expect: { value: '未填寫', status: '', valid: false },
	open: { value: '', status: '', valid: true },
	nickname: { value: '學妹', status: '', valid: false },
	company: { value: '玖樓', status: '', valid: true },
	career: { value: [], list: [], inputValue: '', data: {}, status: '', valid: true },
	intro: { value: '我是一隻魚', status: '', valid: true },
	interests: { value: [], list: [], inputValue: '', data: {}, status: '', valid: false },
	songs: { value: [], favoriteData: {}, status: '', valid: true },
	socialMedia: { value: [], status: '', valid: false, latestIndex: -1 },

	image: { value: '', url: '', valid: false },
};

export default handleActions(
	{
		UPDATE_USER_FIELD: (state, action) => ({
			...state,

			[action.payload.type]: {
				...state[action.payload.type],
				[action.payload.key]: {
					...state[action.payload.type][action.payload.key],
					...action.payload.value,
				},
			},
		}),

		FETCH_USER_FULFILLED: (state, action) => ({
			...state,

			form: {
				...state.form,
				name: { ...state.form.name, ...action.payload.name },
				gender: { ...state.form.gender, ...action.payload.gender },
				jobTypes: { ...state.form.jobTypes, ...action.payload.jobTypes },
				birth: { ...state.form.birth, ...action.payload.birth },
				country: { ...state.form.country, ...action.payload.country },
				professions: { ...state.form.professions, ...action.payload.professions },
				phone: { ...state.form.phone, ...action.payload.phone },
				expect: { ...state.form.expect, ...action.payload.expect },
				open: { ...state.form.open, ...action.payload.open },
				nickname: { ...state.form.nickname, ...action.payload.nickname },
				company: { ...state.form.company, ...action.payload.company },
				career: { ...state.form.career, ...action.payload.career },
				intro: { ...state.form.intro, ...action.payload.intro },
				interests: { ...state.form.interests, ...action.payload.interests },
				socialMedia: { ...state.form.socialMedia, ...action.payload.socialMedia },
				image: { ...state.form.image, ...action.payload.image },
				songs: { ...state.form.songs, ...action.payload.songs },
				certificate: { ...state.form.certificate, ...action.payload.certificate },
			},

			data: action.payload.data,
			social: action.payload.social,
		}),

		SYNC_USER_SETTING_FROM_LOCALSTORAGE: (state, action) => ({
			...state,
			form: action.payload.form,
		}),

		FETCH_USER_JOB_TYPE_OPTION_DATA_FULFILLED: (state, action) => ({
			...state,

			form: {
				...state.form,

				jobTypes: { ...state.form.jobTypes, ...action.payload.jobTypes },
			},
		}),

		FETCH_USER_INTEREST_OPTION_DATA_FULFILLED: (state, action) => ({
			...state,

			form: {
				...state.form,

				interests: { ...state.form.interests, ...action.payload.interests },
			},
		}),

		UPDATE_USER_INTEREST_OPTION_DATA_FULFILLED: (state, action) => ({
			...state,

			form: {
				...state.form,

				interests: { ...state.form.interests, ...action.payload },
			},
		}),

		FETCH_USER_PROFESSION_OPTION_DATA_FULFILLED: (state, action) => ({
			...state,

			form: {
				...state.form,

				professions: { ...state.form.professions, ...action.payload.professions },
			},
		}),

		UPDATE_USER_PROFESSION_OPTION_DATA_FULFILLED: (state, action) => ({
			...state,

			form: {
				...state.form,

				professions: { ...state.form.professions, ...action.payload },
			},
		}),

		FETCH_USER_CAREER_OPTION_DATA_FULFILLED: (state, action) => ({
			...state,

			form: {
				...state.form,

				career: { ...state.form.career, ...action.payload.career },
			},
		}),

		UPDATE_USER_CAREER_OPTION_DATA_FULFILLED: (state, action) => ({
			...state,

			form: {
				...state.form,

				career: { ...state.form.career, ...action.payload },
			},
		}),

		UPLOAD_USER_PHOTO_FULFILLED: (state, action) => ({
			...state,

			form: {
				...state.form,

				image: {
					...state.form.image,
					value: action.payload.image,
					url: action.payload.imageUrl,
				},
			},
		}),

		VALIDATE_USER_DATA: (state, action) => ({
			...state,
			form: {
				...state.form,

				[action.payload.key]: {
					...state.form[action.payload.key],
					status: 'VALIDATED',
					valid: action.payload.valid,
				},
			},
		}),

		CLEAR_VALIDATE_USER_DATA: state => ({
			...state,
			form: {
				...state.form,

				name: { ...state.form.name, status: 'VALIDATING', valid: false },
				gender: { ...state.form.gender, status: 'VALIDATING', valid: false },
				jobTypes: { ...state.form.jobTypes, status: 'VALIDATING', valid: false },
				birth: { ...state.form.birth, status: 'VALIDATING', valid: false },
				country: { ...state.form.country, status: 'VALIDATING', valid: false },
				professions: { ...state.form.professions, status: 'VALIDATING', valid: false },
				phone: { ...state.form.phone, status: 'VALIDATING', valid: false },
				expect: { ...state.form.expect, status: 'VALIDATING', valid: false },
				nickname: { ...state.form.nickname, status: 'VALIDATING', valid: false },
				interests: { ...state.form.interests, status: 'VALIDATING', valid: false },
				socialMedia: { ...state.form.socialMedia, status: 'VALIDATING', valid: false },
				image: { ...state.form.image, status: 'VALIDATING', valid: false },
				certificate: { ...state.form.certificate, status: 'VALIDATING', valid: false },
			},
		}),

		ADD_FAVORITE_SONG: (state, action) => ({
			...state,

			form: {
				...state.form,

				songs: {
					...state.form.songs,
					value: state.form.songs.value.includes(action.payload.id)
						? state.form.songs.value
						: [...state.form.songs.value, action.payload.id],
				},
			},
		}),

		REMOVE_FAVORITE_SONG: (state, action) => ({
			...state,

			form: {
				...state.form,

				songs: {
					...state.form.songs,
					value: state.form.songs.value.filter(id => action.payload.id !== id),
				},
			},
		}),

		FETCH_IG_MEDIA_FULFILLED: (state, action) => ({
			...state,

			userIgData: action.payload.userIgData,
		}),

		REMOVE_IG_ACCESS_TOKEN_FULFILLED: state => ({
			...state,
			userIgData: {
				id: '',
				username: '',
			},
		}),

		ADD_SOCIAL_LINK: (state, action) => ({
			...state,

			form: {
				...state.form,

				socialMedia: {
					...state.form.socialMedia,
					latestIndex: state.form.socialMedia.latestIndex - 1,
					value: [...state.form.socialMedia.value, state.form.socialMedia.latestIndex],
					data: {
						...state.form.socialMedia.data,
						[state.form.socialMedia.latestIndex]: {
							...action.payload,
							id: state.form.socialMedia.latestIndex,
						},
					},
				},
			},
		}),
		REMOVE_SOCIAL_LINK: (state, action) => ({
			...state,

			form: {
				...state.form,

				socialMedia: {
					...state.form.socialMedia,
					value: state.form.socialMedia.value.filter(id => action.payload.id !== id),
				},
			},
		}),
	},
	{
		form: defaultUserData,

		data: {},

		userIgData: {
			id: '',
			username: '',
		},
	},
);



// WEBPACK FOOTER //
// ./src/reducers/user.js